import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Reload when a new deploy is live (installed PWAs stay in memory for days)
const currentBundle = () => [...document.scripts].map((s) => s.src).find((src) => /\/static\/js\/main\.[^/]+\.js$/.test(src));
const checkNewVersion = async () => {
  const cur = currentBundle();
  if (!cur) return;
  try {
    const html = await (await fetch("/", { cache: "no-store" })).text();
    const next = html.match(/\/static\/js\/main\.[^"']+\.js/);
    if (next && !cur.endsWith(next[0])) {
      if ("caches" in window) {
        await (await caches.open("usocial-shell")).put("/", new Response(html, { headers: { "Content-Type": "text/html; charset=utf-8" } }));
      }
      window.location.reload();
    }
  } catch {
    // offline: keep the current version
  }
};
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { checkNewVersion(); } });
setInterval(checkNewVersion, 15 * 60 * 1000);
checkNewVersion();

// Lock pinch-zoom on iOS (Safari ignores user-scalable=no)
["gesturestart", "gesturechange"].forEach((ev) => document.addEventListener(ev, (e) => e.preventDefault(), { passive: false }));

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { reg.update().catch(() => {}); } });
    }).catch(() => {});
    navigator.serviceWorker.addEventListener("controllerchange", () => { if (hadController) { window.location.reload(); } });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
